export default {
  maintenance: "Website is in maintenance. We will be back shortly!",
  maintenance_phone: "App is in maitenance. We will be back shortly!",

  //General phrases
  tollWord: " Fetești bridge fee| Fetești bridge fees | Road taxes",
  vignetteWord: "Road Tax | Road taxes",

  site_tpf: "taxa-pod-fetesti.ro",
  site_erv: "e-rovinieta.ro",

  currency: "leu | lei",
  category: "category",
  select_type_of_vehicle: "Select vehicle type",
  select_the_period: "Select the period",
  or_pay_for: "or pay for",
  your_vehicles_link: "your vehicles",
  or_go_to_your_account_and_buy:
    "Or log into your account and buy directly for your cars",
  see_cart: "See cart",
  or: "or",
  and: "and",
  back: "back",
  total: "Total",
  total_sms: "Total SMS",
  pf: "Natural person",
  pj: "Company",
  yes: "Yes",
  no: "No",
  about: "About",
  us: "Us",

  vignette: "road tax| road taxes",
  passing: "pass | passes",

  toll_buy: "Buy bridge fee",
  vignette_buy: "Buy road tax",
  insurance_buy: "Buy insurance",

  sms_confirm_notification_peaj:
    "I want to receive an SMS confirmation on emission (FREE OF CHARGE) | I want to receive an SMS confirmation on emission (+{price}) | I want to receive an SMS confirmation on emission (+{price})",
  sms_confirm_notification:
    "I want to receive an SMS confirmation on emission (FREE OF CHARGE) | I want to receive an SMS confirmation on emission (+{price}) | I want to receive an SMS confirmation on emission (+{price})",
  sms_expiry_notification:
    "I want to receive an SMS before expiry (FREE OF CHARGE) | I want to receive an SMS before expiry (+{price}) | I want to receive an SMS before expiry (+{price})",
  sms_notification_confirmation:
    "You will receive SMS confirmation on emission (FREE OF CHARGE) | You will receive SMS confirmation on emission (+{price}) | You will receive SMS confirmation on emission (+{price})",
  sms_notification_expiry:
    "You will receive SMS before expiry (FREE OF CHARGE) | You will receive SMS before expiry (+{price}) | You will receive SMS before expiry (+{price})",
  cnair_expiry_notification:
    "I want to receive an email from CNAIR before expiry",
  sms_notification_expiry: "You will receive an email from CNAIR before expiry",

  //Order
  billing_add_new_profile: "Add new billing profile",

  cart_empty: "Cart empty",
  cart_available_from: "valid from",
  cart_add_more: "Add more in cart",
  cart_continue_with_buying: "Buy more",
  cart_validation_errors:
    "Products removed from order due to validation errors",

  order_container_place_order_title: "Place order",
  order_container_my_cart: "My chart",
  order_container_billing_info: "Billing data",
  order_container_payment: "Payment",

  payment_method_insuficient_credit: "insufficient credit",
  payment_method_insuficient_debit: "insufficient debit",
  payment_method_instant_credit: "Instant credit",
  payment_method_instant_credit_description: "Instant credit",
  payment_method_credit_card: "Online or card",
  payment_method_credit_card_description: "Payment processed by PayU.ro",
  payment_method_iTransfer_description:
    "Payment order with immediate confirmation",
  payment_method_payment_order: "Payment order",
  payment_method_payment_order_description:
    "You will receive by email the proforma related to the purchase, containing the payment instructions. The order will be issued upon receipt of payment ",
  payment_method_credit_erv: "E-rovinieta credit",
  payment_method_debit_erv: "E-rovinieta debit",
  payment_method_credit_tpf: "Fetești bridge fee credit",
  payment_method_debit_tpf: "Fetești bridge fee debit",
  payment_method_terms:
    "I confirm that the above data is correct and that I have read and agree to the",
  payment_method_op_not_available_during_weekend:
    "Payment order is disabled between 16:30 PM Thursday and 23:59 PM Sunday",
  payment_method_op_not_available_last_day_of_month:
    "Payment order is disabled in the last day of the month",

  thank_you_placed_order_title: "You order has been placed",
  thank_you_successful_order: "Successful order!",
  thank_you_successful_order_not_loggedin:
    "Successful order! You will receive the invoice containing the emitted vignette on your email.",
  thank_you_see_info_order:
    "Don't start traveling before you receive your vignette confirmation(email or sms), otherwise your risk being fined!",
  thank_you_see_info_order_not_loggedin:
    "Don't start traveling before you receive your vignette confirmation(email or sms), otherwise your risk being fined!",
  thank_you_my_orders: "My orders",
  thank_you_extra_info_not_loggedin:
    "Create an account and save your data for future orders",

  thank_you_itransfer_or_debit_card_or_instant_credit:
    "Please wait for your invoice! Thank you for the payment. In a few moments you will be receiving an email with the confirmation of the order emission. Please don't start driving until you get the confirmation.",
  thank_you_op_payment:
    "We thank you for your order. We have sent the proforma invoice on your email, please make the payment towards the bank account specified in the document and send the proof to contact@e-rovinieta.ro",

  //Account
  continue_with: "Continue with",
  continue: "Continue",
  account_activate_header: "Activate account",
  account_activate_message: "",

  account_container_my_account: "My account",
  account_container_vehicles: "Vehicles",
  account_container_orders: "Orders",
  account_container_profiles: "Billing profiles",
  account_container_info: "Account data",
  account_container_cards: "Cards",

  account_data_title: "Account details",

  add_car_title: "Add car",

  add_profile_title: "Add profile",
  add_profile_pj_extracted: "Company data automatically extracted ",

  edit_profile_title: "Modify profile",
  edit_profile_delete_profile_title: "Delete profile",
  edit_profile_delete_profile: "Are you sure you want to delete the profile?",

  edit_car_no_vehicles: "No vehicle found!",
  edit_car_delete_vehicle_title: "Delete vehicle",
  edit_car_delete_vehicle: "Are you sure you want to delete this vehicle?",

  delete_product_title: "Delete product",
  delete_product: "Are you sure you want to delete this product?",

  my_orders_passings: "one pass | {count} passes",

  profiles_main: "Main",
  profiles_secondary: "Secondary",
  profiles_unverified_data: "Data not verified",
  unverified_company_data_with_manual_completion:
    "Automatic verification unavailable, please manually fill in the fields",
  profiles_no_profile: "No profile",
  profiles_delete_profile: "Delete profile",
  profiles_are_you_sure: "Are you sure you want to delete the profile?",

  search_car_button: "Search",
  search_car_after_license_plate: "Search car plate",
  //Authentication
  login_auth: " Authentication ",
  login_login_into_your_account: "Login into your account",

  login_component_login_by: "Login with",
  login_component_no_account: "You don’t have an account?",
  login_component_forgot_password: "Forgot password?",

  new_account_title: "Register",
  new_account_details: "Account details",
  new_account_ive_read: "I read and agree with",
  new_account_tc: "Terms and conditions",
  new_account_site: "of the site",
  new_account_pc: "Privacy policy",
  mandatory: "Mandatory",
  new_account_must_accept_tc: "You must agree with the terms and conditions",
  new_account_must_accept_pc: "You must agree with privacy policy",

  contact_title: "Contact",

  faq_title: "Frequent questions",

  header_how_does_it_work: "How it works?",

  //menu pages
  how_it_works: "How it works",
  for_companies: "For companies",
  distribution_untrr: "UNTRR distribution points",

  how_it_works_p1: "You can leave in 3 minutes!",
  how_it_works_p2: "CNAIR authorized distributor",
  how_it_works_p3: "Order online with taxa-pod-fetesti.ro",

  toll_category_error_loading_car: "Problem on loading car data",
  toll_category_error_loading_country: "Problem on loading countries",

  vignette_category_error_fromdate:
    "Select the date when the road tax validity starts",
  vignette_category_chasis_warning_msg:
    "For 1 day valability vignettes the chassis number is not mandatory",
  vignette_category_chasis_warning_msg_7:
    "For 7 days valability vignettes the chassis number is not mandatory",

  reset_password_title: "Reset password",
  reset_password_label: "Email",

  reset_password_update_title: "Save new password",

  //Buttons
  btn_save: "Save",
  btn_save_changes: "Save changes",
  btn_add_car: "Add car",
  btn_delete_car: "Delete car",
  btn_next_step: "Next step",
  btn_finish: "Finish",
  btn_grab_data_company: "Retrieve data<br/> Trade Register",
  btn_add_profile: "Add new profile",
  btn_i_understand: "I understand",
  btn_login: "Login",
  btn_register: "register",
  btn_create_account: "Create account",
  btn_add_to_cart: "Add to chart",
  btn_edit_to_cart: "Edit product",
  btn_reset_password: "Reset password",
  btn_bill: "Bill",
  btn_choose_payment_method: "Choose payment method",
  btn_send: "Send message",

  //Labels
  label_category: "Category",
  label_choose_category_contact: "Choose category",
  label_message: "Message",
  label_email: "Email",
  label_password: "Password",
  label_confirm_password: "Confirm password",
  label_phone: "Phone",
  label_license_plate: "License plate",
  label_chasis_number: "Chassis number",
  label_registration_country: "Registration country",
  label_motif: "Lower category reason",
  label_choose_category: "Select category for",
  label_billing_type: "Billing for",
  label_last_name: "First name",
  label_first_name: "Name",
  label_country: "Country",
  label_county: "County",
  label_city: "City",
  label_address: "Address",
  label_cui: "Sole registration number",
  label_reg_com: "Trade Register registration number",
  label_locality: "Place",
  label_company_name: "Company name",
  label_for_car: "For vehicle",
  label_available_from: "Valid from",

  //terms
  terms: "Terms and conditions",
  partners: "Partners",
  distribution: "Distribution points",
  legislative_info: "Legislative information",

  //info
  info_download_file: "Download file",

  //New terms
  btn_edit: "Edit",
  btn_edit_password: "Edit password",
  btn_edit_phone: "Edit phone no.",
  btn_delete_account: "Delete account",
  btn_import_csv: "Import csv",
  btn_export_csv: "Export csv",

  //account
  data_saved_succesfully: "Data successfully saved",
  invalid_plate_number_message: "Invalid license plate format",
  invalid: "Invalid",
  countries_loading: "Problem loading countries",
  tpf_categories_loading: "Problem loading Fetești bridge fee categories",
  erv_categories_loading: "Problem loading RO-vignette categories",
  csv_header:
    '"License plate no.","VIN","RO-vignette category","Fetești bridge fee category","Country"',
  order_header_name: "Name",
  date: "Date",
  order_header_payment_type: "Payment type",
  order_header_status: "Status",
  no_placed_order: "No placed orders.",
  i_want: "I want",
  no_order: "Error finding order.",
  delete_request_sent_message: "Account delete request sent successfully",
  delete_request_already_sent_message: "Account delete request already sent",

  product_status: "Status",
  product_payment_method: "Payment method",
  product_bill_data: "Billing info",
  product_valability: "Validity",

  download_bill: "Download bill",
  download_client_copy: "Download client copy",
  download_bill_sms: "Download bill SMS",
  vignette_series: "RO-vignette series",
  toll_series: "Toll series",

  //authentication
  login_account: "Log into your account",
  already_have_account: "Already have an account?",
  password: "Password",
  password_confirm: "Confirm password",
  return_to_login_1: "Return to",
  return_to_login_2: "Login",

  // order
  order_title: "Details of your order with ID #",
  choose_profile: "Choose profile",
  order_step4: "Step 4: Billing",
  login_to_your_account: "Log into your account",
  login_to_your_account_2: "and select the already saved billing info.",
  order_without_account: "To order without an account, enter the data below",
  fill_all_fields: "Fill all mandatory fields",
  order_address_info:
    "The bill and the RO-vignette will be sent to this address",
  invalid_profile_msg: "This is not a valid profile",
  delete_profile_msg: "Delete profile",
  delete_profile_confirm: "Are you sure you want to delete the profile?",
  invalid_email: "Invalid email",
  invalid_tel: "Invalid telephone no.",
  mandatory_city: "The City field is mandatory",
  mandatory_first_name: "The First name field is mandatory",
  mandatory_last_name: "The Surname field is mandatory",
  mandatory_country: "The County field is mandatory",
  mandatory_fiscal_code: "The Sole Registration Code field is mandatory",
  mandatory_j_code: "The Trade Registry no. field is mandatory",
  mandatory_company: "The Company field is mandatory",
  mandatory_address: "The Address field is mandatory",
  my_shopping_cart: "My cart",
  order_step3: "Step 3: Summary",
  buy_vignette_or_bridge_fee:
    "You can buy a RO-vignette or a Fetești bridge passing fee",
  order_step5: "Step 5: Payment",
  warning: "WARNING!",
  warning_txt_1:
    "For RO-vignettes settled via payment order, the order will only be approved after the money is credited into UNTRR’s bank account.",
  warning_txt_2:
    "RO-vignettes settled via payment order are issued Monday to Friday, 08am – 4:30pm.",
  warning_txt_3:
    "Don’t set off before receiving the RO-vignette issue confirmation.",
  warning_txt_4:
    "UNTRR is not liable for the failure to observe the provisions above!",
  choose_card: "Choose one of your saved cards",
  new_card: "New card",
  add_card_for_next_transactions: "Add card to my account for future purchases",

  free: "Free",
  btn_logout: "Log out",
  info: "Legislative information",

  frequent_questions_heading: "Frequently Asked Questions and Answers",
  see_all_frequent_questions:
    "See all Frequently Asked Questions and the answers",

  step: "Step {n}",
  choose_passings_number: "Choose no. of passings",
  vehicles: "Motor vehicles",

  juridical_person: "Legal person",
  individual_person: "Natural person",
  auto_query_company_data: "We automatically retrieve your company data",
  verified_company_data: "Verified company data!",
  unverified_company_data: "Unverified company data",
  check_vignette_valability: "Check RO-vignette validity",
  resources: "Resources",
  i_want_vignette: "Buy a RO-vignette",
  i_want_toll: "Pay the Fetești Bridge fee",
  i_want_insurance: "Buy an insurance",
  vehicle_type: "Vehicle type",
  period: "Period",
  summary: "Summary",
  billing: "Billing",

  payment: "Payment",
  you_have_multiple_usernames:
    "You have <b>{count}</b> accounts associated to this email.",
  choose_login_account: "Choose the account with which you want to log in",

  //benefits page
  bp_heading: "In addition",
  bp_company_advantages: "Benefits for companies",
  bp_one_account_multiple_advantages: "One account, several benefits",
  bp_contact_us_for_personalized_solution:
    "Contact us for a customized solution",
  bp_online_emission: "Online issue 24/7",
  bp_online_assistance:
    "You benefit from online support and you can buy a RO-vignette or pay the Fetești Bridge toll 24/7",
  bp_import_your_cars: "Import all motor vehicle fleet",
  bp_import_you_cars_through_excel:
    "Import all your motor vehicle fleet with us, via an Excel file.",
  bp_multiple_profiles: "Multiple profiles",
  bp_multiple_profiles_for_same_email:
    "You can create several profiles for your company’s users, using the same email address.",
  bp_vignettes_status: "RO-vignette status",
  bp_verify_vignette_status:
    "You can check the status of the issue RO-vignette on our website at all times.",
  bp_orders_history: "Order history",
  bp_orders_history_description:
    "In your account you can find all placed and billed orders.",
  bp_multiple_orders: "Multiple orders",
  bp_multiple_orders_description:
    "You can add several RO-vignettes to your cart and place multiple orders.",
  bp_email_sms_confirmation: "Confirmation by email and SMS",
  bp_email_sms_confirmation_description:
    "Receive the RO-vignette issue confirmation by email and SMS.",
  bp_expiry_alerts: "Expiry alerts",
  bp_expiry_alerts_description:
    "For 30-day and above RO-vignettes, we will alert you by email before they expire.",
  bp_need_help: "Need help?",
  bp_call_operators:
    "Call one of our operators for RO-vignette issue support. The service is available Monday to Friday (except for legal holidays), 8am – 5pm.",
  bp_offices: "List of offices",
  bp_have_cars: "Do you hold a motor vehicle fleet?",
  bp_contact_us_for_personalized_solution_for_your_bussiness:
    "Contact us for a customized solution for your business.",
  bp_contact_us_now: "Contact us now",

  //contact
  contact_viggnete_emission: "RO-vignette issue",
  contact_agencies: "Agencies",
  contact_see_all_agencies: "See all regional agencies",
  contact_see_all_agencies_continuation: "from which you can buy RO-vignettes.",
  message_sent_successfully:
    "Message successfully sent! We will contact you shortly!",
  message_sent_error:
    "There was a problem with sending your message. Please try again later!",
  category_1: "Vignette valability",
  category_2: "Orders",
  category_3: "Vignette payment",
  category_4: "Companies offers",
  category_5: "Other information",

  //distribution
  distribution_header:
    "THE LIST OF UNTRR BUSINESS UNIT AUTHORIZED TO COLLECT THE FEE FOR THE USE OF NATIONAL ROADS IN ROMANIA (RO-VIGNETTE)",
  distribution_nr_crt: "Item no.",
  distribution_work_point: "Business unit",
  distribution_terminals_and_portals: "TERMINALS AND WEB PORTALS",
  distribution_name: "Designation",
  distribution_terminals: "ZEBRAPAY terminals",
  distribution_location_terminal_details: "ZEBRAPAY terminal location details",
  distribution_untrr_portal: "UNTRR PORTAL",

  //footer
  footer_copyright:
    "All rights reserved 2010 - {currentYear} @ National Union of Road Hauliers from Romania.",
  about_us: "About us",
  cookies: "Cookies",
  footer_new_account_link: "Join the professionals",

  //homepage
  homepage_authorized_distributor: "Authorized C.N.A.I.R retailer",
  homepage_buy_tpf_erv: "Buy a RO-vignette or a Fetești bridge passing fee",
  homepage_ready_for_road: "Ready to set off in a matter of minutes",
  homepage_order: "Order",
  homepage_payment: "Pay",
  homepage_drive: "Drive",
  homepage_your_advantages: "Your advantages",
  homepage_vignette_availability: "Check the validity of the RO-vignette",
  homepage_vignette_availability_description_1:
    "Don’t know if you have a valid RO-vignette? Avoid the fines.",
  homepage_vignette_availability_description_2: "Check validity here",
  homepage_save_data: "Save data",
  homepage_save_data_description:
    "You create an account, save all vehicle data, and buy the RO-vignette and the Fetești bridge fee, all in one place.",
  homepage_sms_email_delivery: "Delivery by email and SMS",
  homepage_sms_email_delivery_description: "Delivery by email and SMS",
  homepage_card_or_op: "Pay by card or PO",
  homepage_card_or_op_description:
    "Quick and safe purchase by credit card or PO.",
  homepage_notify_expiry: "You receive an expiry notice",
  homepage_notify_expiry_description:
    "For RO-vignetted valid for more than 30 days, we alert you before they expire.",
  homepage_professional_services: "Professional services",
  homepage_professional_services_description:
    "From road carriage professionals for all the users of the Romanian road network.",
  homepage_online_assistance:
    "In addition, you benefit from online support and receive a solution that is tailored to your company’s needs.",
  homepage_discover_all_benefits: "Discover all the benefits",
  homepage_distribution_points: "Points of sale",
  homepage_authorized_distributor_2:
    "UNTRR is a retailer authorized by C.N.A.I.R. for the issue of electronic RO-vignettes, present both in the online environment, and in the territory, with multiple points of sale.",
  homepage_distribution_points_description:
    "See the list of the points of sale",
  homepage_frequent_questions: "Frequently Asked Questions and Answers",
  homepage_frequent_questions_description:
    "See all Frequently Asked Questions and the answers",

  //reset
  reset_cart: "Your cart was reset.",

  buy_vignette: "Buy vignette",
  buy_toll: "Buy Fetești bridge toll",

  no_saved_credit_card: "No saved credit cards",
  card_delete_title: "Delete card",
  card_delete_body: "Are you sure you want to delete your card?",

  //verify vignette
  verify_vignette_title: "Check vignette",
  heel_series: "Heel series",
  heel_number: "Heel number",
  request_verify_vignette: "Verify with CNAIR",
  btn_verify: "Verify",
  vignette_available_until: "Vignette available until ",
  error:
    "There has been an error regarding your request, please try again later.",
  you_will_be_contacted:
    "UNTRR operators will check the status of your vignette and will send you a response between 08:00 and 17:00.",

  //cars
  show_all_vehicles: "Show all vehicles",
  show_only_active_vignette_vehicles: "Active vignettes",
  show_only_expired_vignette_vehicles: "Expired vignettes",

  sort_by_car_name: "Car plate alfa alphabetically",
  sort_vignette_expiry: "Vignette expiry date",

  //vehicles
  active: "Active until ",
  expired: "Expired",
  unknown: "Unknown",
  vignette_status: "Vignette status",
  btn_show_more_info: "Show import informations",
  btn_show_less_info: "Hide import informations",
  imported_vehicles:
    "{vehicles} vehicle was imported | {vehicles} vehicles were imported",

  //orders
  choose_status: "Choose order status",
  continue_payment: "Continue payment",

  overlapping_products:
    "This product is overlapping another product already added to your cart",
  aleady_active_vignette:
    "There is already an existing active vignette for the car until {date}",

  Zi_1: "1 day",
  Zi_7: "7 days",
  Zi_10: "10 days",
  Zi_60: "60 days",
  Zi_30: "30 days",
  Zi_90: "90 days",
  Luna_12: "12 months",
  days: "1 day | {count} days",
  months: "1 month | {count} months",

  see_all_your_vehicles: "Check all your vehicles",
  here: "here",

  fill_in_tpf_category: "Select Fetești bridge category",
  fill_in_erv_category: "Select vignette category",

  chasis_number_warning: "Chasis number is mandatory for vignettes up to {label}",
  please_check_informations:
    "Please make sure that the license plate you supplied is correct before you continue towards the payment gateway. Thank you!",

  sort_by: "Sort by",
  type: "Type",

  payment_method_instant_debit: "Debit instant",
  payment_method_instant_debit_description:
    "You'll pay from your allocated sum",

  new_app_version_android: "New app version, please update it on the market!",
  new_app_version_ios: "New app version, please update it on the appstore!",

  sms_notice: `
    <strong>Notice by SMS Service for a fee</strong><br/><br/>
    The notification service through short messages (SMS) allows the notification of www.e-rovinieta.ro customers to confirm the issuance of vignette or Fetesti bridge toll and the expiration of vignettes.<br/><br/>
    The service is optional, for a fee, at the customers' choice, and is only valid for orders paid online through the payment processor (PayU).<br/><br/>
    Notification is possible only for users of national (Romania) mobile networks.<br/><br/>
    The notification by SMS for the confirmation of the vignette/Fetesti bridge toll  is made immediately after the order is completed, and the notification by SMS for the expiry of the vignette is made 7 days before the expiry of the vignette.<br/><br/>
    The correctness of the data and information from the SMS about the issuing of the vignette/Fetesti bridge toll , the registration number, the chassis series and the mobile phone number, entered in the www.e-rovineta.ro platform are strictly the responsibility of the user.<br/><br/>
    The SMS notification is made by NETOPIA Payments.<br/><br/>
    The SMS notification system sends notifications to customers who opt for this service for a fee.<br/><br/>
    The reception of SMS can be affected by the operation and coverage areas of the telecommunications networks, by the operation of the devices used, the non-functionality of the IT systems, and so on.<br/><br/>
    For notifications, situations in which you do not receive sms, please use the <a href="https://www.e-rovinieta.ro/en/contact">contact</a> page of the website.<br/><br/>
    U.N.T.R.R. cannot be responsible for damages of any kind that the user or any third party may suffer as a result of not receiving the sms.<br/><br/>
  `,

  start_valability: 'From',
  end_valability: 'To',
  btn_report_emitted: 'Generate report emitted {type}',
  btn_export_all_orders: 'Export all orders',
  no_reponse_data: 'No {type} found in this interval',

  captch_error_msg: 'reCaptcha check failed, please try again',

  homepage_partners: 'Partner websites'
};
